import { styled, Typography } from '@material-ui/core';

import { down } from '../../../assets/style/breakpointHelpers';

export const FooterContainer = styled('div')({
	display: 'flex',
	flexWrap: 'wrap',
	padding: '15px',
	alignItems: 'center',
	justifyContent: 'space-between',
	zIndex: 4,
	marginTop: 'auto',
	borderTop: '1px solid var(--color-border-subtle)',
	background: 'var(--color-bg-primary)',
	width: '100%',
	transition: 'background-color var(--transition-normal), border-color var(--transition-normal)',
	[down('md')]: {
		flexDirection: 'column-reverse',
	},
});

export const Copyright = styled(Typography)({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-body-sm-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	color: 'var(--color-text-secondary)',
	[down('md')]: {
		marginTop: 10,
		fontSize: 'var(--type-xs)',
	},
});

export const Logo = styled('img')({
	marginRight: 20,
	maxHeight: 70,
	maxWidth: 352,
	width: '100%',
	height: '100%',
});
